// extracted by mini-css-extract-plugin
module.exports = {"pageNF":"SupActivity_pageNF__yzQrs","spinner":"SupActivity_spinner__LSJic","chart":"SupActivity_chart__2QPBx","tagfont":"SupActivity_tagfont__3ngj9"};